import { createContext, useContext, useEffect } from 'react';
import { AnimatePresence, usePresence } from 'framer-motion';

const SheetPhase = createContext(true);
const CLOSE_DURATION = 200;

function SheetLifetime({ children }) {
  const [present, remove] = usePresence();
  useEffect(() => {
    if (present) return;
    const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    if (reduced) { remove(); return; }
    const timer = setTimeout(remove, CLOSE_DURATION);
    return () => clearTimeout(timer);
  }, [present, remove]);
  return <SheetPhase.Provider value={present}>{children}</SheetPhase.Provider>;
}

// Keep the last rendered sheet alive until its closing animation completes.
// React context also reaches dialogs rendered through a portal.
export function SheetPresence({ children }) {
  return <AnimatePresence>{children && <SheetLifetime key="sheet">{children}</SheetLifetime>}</AnimatePresence>;
}

export function SheetRoot({ as: Component = 'div', className = '', ...props }) {
  const present = useContext(SheetPhase);
  return <Component {...props} inert={present ? undefined : ''} data-sheet-state={present ? 'open' : 'closing'} className={`sheet-root ${present ? 'sheet-enter' : 'sheet-leave'} ${className}`} />;
}
